import { CtgListData } from "@/components/business/CtgListContainer/ctgList.types";
import { PatentListData } from "@/components/business/PatentContainer/Patent.types";
import { PublicationListData } from "@/components/business/PublicationListContainer/publicationList.types";
import { RegulatoryListData } from "@/components/business/RegulatoryContainer/Regulatory.types";
import { DRAFT_STATUS_LIST } from "@PressListContainer/draftStatusInfo.constants";
import { PressListData } from "@PressListContainer/pressList.types";

export const handleDraftError = (data: PressListData): [boolean, string] => {
  const { pressId, pressTitle, companyName, draftArticleStatus } = data;
  if (!pressId) {
    return [true, "Press Id is empty"];
  }
  if (!pressTitle) {
    return [true, "Press Title is empty"];
  }
  if (!companyName) {
    return [true, "Company Name is empty"];
  }
  if (!draftArticleStatus) {
    return [true, "Article Status is empty"];
  }
  if (!DRAFT_STATUS_LIST.includes(draftArticleStatus)) {
    return [true, "Article Status is not valid"];
  }
  return [false, ""];
};

export const handleCtgError = (data: CtgListData): [boolean, string] => {
  const { id, draftArticleStatus } = data;
  if (!id) {
    return [true, "Id is empty"];
  }
  if (!draftArticleStatus) {
    return [true, "Article Status is empty"];
  }
  if (!DRAFT_STATUS_LIST.includes(draftArticleStatus)) {
    return [true, "Article Status is not valid"];
  }
  return [false, ""];
};

export const handleRegulatoryListError = (
  data: RegulatoryListData,
): [boolean, string] => {
  const { id, draftArticleStatus } = data;
  if (!id) {
    return [true, "Id is empty"];
  }
  if (!draftArticleStatus) {
    return [true, "Article Status is empty"];
  }
  if (!DRAFT_STATUS_LIST.includes(draftArticleStatus)) {
    return [true, "Article Status is not valid"];
  }
  return [false, ""];
};

export const handlePatentListError = (
  data: PatentListData,
): [boolean, string] => {
  const { id, draftArticleStatus } = data;
  if (!id) {
    return [true, "Id is empty"];
  }
  if (!draftArticleStatus) {
    return [true, "Article Status is empty"];
  }
  if (!DRAFT_STATUS_LIST.includes(draftArticleStatus)) {
    return [true, "Article Status is not valid"];
  }
  return [false, ""];
};

export const handlePublicationListError = (
  data: PublicationListData,
): [boolean, string] => {
  const { publicationId, title, draftArticleStatusHighest } = data;
  if (!publicationId) {
    return [true, "Publication Id is empty"];
  }
  if (!title) {
    return [true, "Title is empty"];
  }
  if (!draftArticleStatusHighest) {
    return [true, "Article Status Highest is empty"];
  }
  if (!DRAFT_STATUS_LIST.includes(draftArticleStatusHighest)) {
    return [true, "Article Status Highest is not valid"];
  }

  return [false, ""];
};
